import React, { useState, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import { GMOAA } from "@/constants/testIds";

function diff(target) {
  const now = new Date().getTime();
  const d = Math.max(0, target - now);
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor((d % 86400000) / 3600000),
    minutes: Math.floor((d % 3600000) / 60000),
    seconds: Math.floor((d % 60000) / 1000),
  };
}

export const GaplCountdown = ({ startDate, compact = false, title }) => {
  const { t } = useLang();
  const target = new Date(startDate).getTime();
  const [time, setTime] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => setTime(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { v: time.days, l: t("days") },
    { v: time.hours, l: t("hours") },
    { v: time.minutes, l: t("minutes") },
    { v: time.seconds, l: t("seconds") },
  ];

  return (
    <div data-testid={GMOAA.gaplCountdown} className={compact ? "" : "rounded-2xl border border-gmoaa-gold/50 bg-gmoaa-green p-5 text-white shadow-lg"}>
      {!compact && <p className="mb-3 text-sm font-medium text-gmoaa-gold-light">{title || t("gaplCountdownTitle")}</p>}
      <div className="grid grid-cols-4 gap-2">
        {units.map((u) => (
          <div key={u.l} className="rounded-lg bg-white/10 px-2 py-2 text-center backdrop-blur-sm">
            <p className="font-serif text-2xl font-bold tabular-nums">{String(u.v).padStart(2, "0")}</p>
            <p className="mt-0.5 text-[10px] uppercase tracking-wide text-gmoaa-gold-light">{u.l}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
